import { render, staticRenderFns } from "./DisputeEvidenceUpload.vue?vue&type=template&id=5411ed05&"
import script from "./DisputeEvidenceUpload.vue?vue&type=script&lang=js&"
export * from "./DisputeEvidenceUpload.vue?vue&type=script&lang=js&"
import style0 from "./DisputeEvidenceUpload.vue?vue&type=style&index=0&id=5411ed05&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports